var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.919 16.039a17.74 17.74 0 00-3.85-1.69c-9.217-2.78-22-3.745-30.825.788a17.23 17.23 0 00-6.746 6.178C3.66 27.43 1.181 33.682 4.673 40.778c2.262 4.596 6.324 6.822 9.195 10.731 5.446 7.416 3.633 19.04 11.943 24.31 6.093 3.863 13.878 2.026 19.908-1.112 6.083-3.165 11.343-8.492 14.383-15.095a31.905 31.905 0 001.813-4.992c3.497-12.908-1.62-31.914-12.996-38.581z",
    fill: "#E7F3F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.108 60.356a10.05 10.05 0 007.088-2.886l10.236-10.064c.718-.709 1.97-.707 2.69 0l10.272 10.1a10.05 10.05 0 007.089 2.887H67.5L54.537 73.139c-4.05 3.981-10.613 3.981-14.661 0L26.875 60.356h1.233zM65.483 23.598a10.053 10.053 0 00-7.089 2.884L48.121 36.579c-.74.727-1.948.73-2.69-.001l-10.235-10.06a10.052 10.052 0 00-7.088-2.884h-1.233l13-12.775c4.05-3.979 10.613-3.979 14.662 0L67.5 23.598h-2.017z",
    fill: "#e80070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.912 34.905l7.744-7.494H28.9c1.847 0 3.655.725 4.96 1.989l10.236 9.906a4.986 4.986 0 003.475 1.39 4.987 4.987 0 003.474-1.39l10.275-9.942c1.305-1.264 3.113-1.989 4.96-1.989h5.027l7.782 7.53c4.05 3.919 4.05 10.271 0 14.19l-7.782 7.53h-5.027c-1.847 0-3.655-.725-4.96-1.989l-10.274-9.942c-1.857-1.795-5.094-1.796-6.95.001L33.86 54.6c-1.305 1.264-3.113 1.989-4.96 1.989h-4.243l-7.744-7.494c-4.05-3.919-4.05-10.271 0-14.19z",
    fill: "#e80070"
  })));
}

export default "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/pix-cb6702b38fa2dfd187113457232d0d16.svg";
export { SvgPix as ReactComponent };